import { Loader } from '@mantine/core';
import { ErrorView, variants } from '@uag/react-core';
import { clsx } from 'clsx';

import { useGetCurrentUserDetails } from 'api/v3/user/user';
import { ProfileHead } from './ProfileHead';
import { ProfileTab } from './ProfileTab';

type ProfileProps = {
    className?: string;
};

export const ProfileShell = ({ className }: ProfileProps) => {
    const { data: currentUser, isLoading: isUserLoading, error } = useGetCurrentUserDetails();

    if (isUserLoading) {
        return <Loader variant={variants.loader.loadingAnimation} />;
    }
    if (error) {
        return <ErrorView description={(error.message as string) ?? ''} title={(error.name as string) ?? ''} />;
    }
    if (!currentUser) {
        return null;
    }
    const user = currentUser.data;

    return (
        <div className={clsx(className, 'flex flex-col gap-12 sm:gap-4')}>
            <ProfileHead user={user} />
            <ProfileTab user={user} />
        </div>
    );
};
